import React from 'react';
import PropTypes from 'prop-types';
import findByString from "../../../../../../../../../Utils/Form/FormDynamic/Utils/getValueByString";
import TypographySetup from "../../../../../../../../../Utils/TypographySetup";

const TypographyStyle = ({label, path, setValue, values, disabled}) => {
    /*names
    * 1.fontSize
    * 2.fontStyle
    * 3.fontWeight
    * 4.textAlign
    * 5.textDecoration
    * 6.color
    * 7.background
    * */
    const fieldValue = findByString(values, path) || {};

    function onChange(value) {
        setValue({
            ...fieldValue,
            ...value,
            fontSize: `${value.fontSize.size || 0}${value.fontSize.type || 'px'}`
        }, path);
    }

    function getFontSizeObject() {
        let size = fieldValue.fontSize || '0px';
        let type = size.match(/px/g) || [];
        let numberSize = size.match(/[-+]?[0-9]*\.?[0-9]/g) || [];
        return {
            size: numberSize[0] || '0',
            type: type[0] || 'px'
        }
    }

    let fontSize = getFontSizeObject();
    return (
        <div style={{display: 'flex'}}>
            <div style={{width: 102}}>{label}</div>
            <div style={{width: 20}}>
                <TypographySetup
                    setValues={onChange}
                    values={{...fieldValue, fontSize}}
                    updateOnChange
                    path={path}
                    disabled={disabled}
                />
            </div>
        </div>
    )
};

TypographyStyle.propTypes = {
    label: PropTypes.string,
    path: PropTypes.string,
    setValue: PropTypes.func,
    values: PropTypes.object
};

export default TypographyStyle;